// extracted by mini-css-extract-plugin
export default {"crawlingAnt":"wavyConnectorLine_crawlingAnt__dI-JW","dashMove":"wavyConnectorLine_dashMove__JFVn9"};